import {lazy} from 'react';

export const isChunkLoadError=error=>/ChunkLoadError|Loading (?:CSS )?chunk|Failed to fetch dynamically imported module|Importing a module script failed/i.test(error?.name+' '+error?.message);

// Retry transient downloads, then refresh a stale deployment once per page module.
// Keep the full current URL, including checkout callback parameters.
function sessionStorageOrNull(){try{return window.sessionStorage;}catch(_){return null;}}
export async function loadRoute(importPage,name,{storage=sessionStorageOrNull(),reload=()=>window.location.reload()}={}){
 const key='earlybird:route-reload:'+name;
 try{
  let page;
  try{page=await importPage();}
  catch(error){
   if(!isChunkLoadError(error))throw error;
   page=await importPage();
  }
  try{storage.removeItem(key);}catch(_){}
  return page;
 }catch(error){
  if(isChunkLoadError(error)){
   let shouldReload=false;
   try{
    if(!storage.getItem(key)){storage.setItem(key,'1');shouldReload=true;}
   }catch(_){}
   if(shouldReload){
    reload();
    // Keep the loading state mounted while the browser loads the fresh document.
    return new Promise(()=>{});
   }
  }
  throw error;
 }
}
export const lazyRoute=(importPage,name)=>lazy(()=>loadRoute(importPage,name));
